import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/flipbook/[document]/Flipbook.tsx");
